<!--<app-navigation [globalContent]="globalContent"></app-navigation>-->
<router-outlet></router-outlet>
